import InterestingNumbers from './InterestingNumbers.svelte';

export default {
  component: InterestingNumbers,
  name: 'Interesting Numbers',
  inputs: [
    {
      name: 'title',
      type: 'richText'
    },
    {
      name: 'description',
      type: 'richText'
    },
    {
      name: 'uniqueOffers500mToSubway',
      type: 'number'
    },
    {
      name: 'uniqueOffers500mToSubwayDescription',
      type: 'richText'
    },
    {
      name: 'uniqueOffersWithPriceChangeDown',
      type: 'number'
    },
    {
      name: 'uniqueOffersWithPriceChangeDownDescription',
      type: 'richText'
    },
    {
      name: 'duplicatesAmount',
      type: 'number'
    },
    {
      name: 'duplicatesAmountDescription',
      type: 'richText'
    },
    {
      name: 'uniqueOffersForRenovation',
      type: 'number'
    },
    {
      name: 'uniqueOffersForRenovationDescription',
      type: 'richText'
    },
  ]
}
